import { cn } from "../../lib/utils";
import { label } from "../../lib/format";

const CAT_STYLES = {
  draft: "bg-slate-100 text-slate-700 border-slate-300",
  filing: "bg-amber-50 text-amber-800 border-amber-200",
  committee: "bg-sky-50 text-sky-800 border-sky-200",
  session: "bg-indigo-50 text-indigo-800 border-indigo-200",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  executive: "bg-violet-50 text-violet-800 border-violet-200",
  review: "bg-orange-50 text-orange-800 border-orange-200",
  publication: "bg-cyan-50 text-cyan-800 border-cyan-200",
  effective: "bg-green-100 text-green-800 border-green-300",
  archived: "bg-slate-100 text-slate-500 border-slate-300",
};

export const StatusBadge = ({ category, name, testId }) => (
  <span
    data-testid={testId || `status-badge-${category || "unknown"}`}
    className={cn("inline-flex items-center whitespace-nowrap rounded border px-2 py-0.5 text-[11px] font-medium", CAT_STYLES[category] || CAT_STYLES.draft)}
  >
    {name || label(category)}
  </span>
);

const PRIORITY = { urgent: "text-red-700 bg-red-50 border-red-200", high: "text-amber-800 bg-amber-50 border-amber-200", normal: "text-slate-600 bg-white border-slate-200", low: "text-slate-500 bg-slate-50 border-slate-200" };

export const PriorityBadge = ({ value }) => (
  <span className={cn("inline-flex rounded border px-1.5 py-0.5 text-[11px] capitalize", PRIORITY[value] || PRIORITY.normal)}>{value}</span>
);

export const ConfBadge = ({ value }) =>
  value === "confidential" || value === "restricted" ? (
    <span className="inline-flex rounded border border-red-200 bg-red-50 px-1.5 py-0.5 text-[11px] font-medium uppercase text-red-700">{value}</span>
  ) : null;
